// extracted by mini-css-extract-plugin
module.exports = {"prime":"styles_prime__NVfNH"};